import { setAccessToken } from "./token-store"

// Single-flight refresh shared by every caller (SWR fetcher, mutations, auth
// provider). The backend rotates refresh tokens and blacklists the old one,
// so a refresh token is single-use: two concurrent refreshes would burn the
// token and log the user out. Dedupe by sharing one in-flight promise.
let pendingRefresh: Promise<boolean> | null = null

export function refreshSession(): Promise<boolean> {
  if (!pendingRefresh) {
    pendingRefresh = fetch("/api/auth/refresh", {
      method: "POST",
      credentials: "include",
    })
      .then(async (r) => {
        if (r.ok) {
          const data = await r.json().catch(() => ({}))
          if (data.accessToken) setAccessToken(data.accessToken)
          return true
        }
        return false
      })
      .catch(() => false)
      .finally(() => {
        pendingRefresh = null
      })
  }
  return pendingRefresh
}
